import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AliyunUpload from 'aliyun-upload-vod'
import OSS from 'ali-oss'

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局样式
import './assets/styles/global.scss'
window.AliyunUpload = AliyunUpload
window.OSS = OSS

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
